import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingSpinner = ({ 
  size = 'md', 
  className = "",
  text = null 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <Loader2 className={`animate-spin ${sizeClasses[size]}`} />
      {text && <span className="text-sm text-gray-600">{text}</span>}
    </div>
  );
};

export const LoadingOverlay = ({ 
  children, 
  loading, 
  text = "Loading..." 
}) => {
  return (
    <div className="relative">
      {children}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 pointer-events-none rounded-lg">
          <div className="bg-white px-4 py-2 rounded-lg shadow-sm">
            <LoadingSpinner text={text} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;